import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=674bb400&scoped=true"
import script from "./paySuccess.vue?vue&type=script&lang=js"
export * from "./paySuccess.vue?vue&type=script&lang=js"
import style0 from "./paySuccess.vue?vue&type=style&index=0&id=674bb400&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674bb400",
  null
  
)

export default component.exports